import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, InputLabel, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';

import { getmawbstatistics } from '../../../actions/batchManagementActions';

const useStyles = makeStyles((theme)=> ({
    dialogPaper: {
        minHeight: '80vh'
    }
}))


function PaperComponent(props) {
    return (
      <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
}
  
export default function StaticsDialog(props) {
    const { openModal, onClose} = props;

    const classes = useStyles();
    const {t} = useTranslation('batchManagement');
    const dispatch = useDispatch();

    const OPTION_PLS_SELECT = '-1';
    const ROW_MAX_COLUMN = 2;

    const batchList = useSelector(state => state.batchManagement.batchList) || [];
    const mawbstatistics = useSelector(state => state.batchManagement.mawbstatistics) || [];

    const [masterAirWayBill,setMasterAirWayBill] = useState();
    const [masterAirWayBillList,setMasterAirWayBillList] = useState([]);

    const [unscanned,setUnscanned] = useState();
    const [delivered,setDelivered] = useState();
    const [parcelScanned,setParcelScanned] = useState();
    const [returnStorage,setReturnStorage] = useState();
    const [inStorage,setInStorage] = useState();
    const [inTransit,setInTransit] = useState();


    useEffect(() => {      
        if (openModal === true)  {
            //initialization the variable
            init();
        }        
    },[openModal]);    

    useEffect(() => {      
        if (mawbstatistics.length > 0)  {
        }        
    },[mawbstatistics]);    
    
    return (        
            <Dialog 
                open={openModal}
                onClose={handleClose} 
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth='sm'
                scroll='body'
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {t('title_statics_result')}
                    <span style={{float: "right"}}>
                        <Tooltip title={t('common:cancel')} aria-label="cancel" >
                            <CloseIcon onClick={handleClose}></CloseIcon>
                        </Tooltip>        
                    </span>
                </DialogTitle>
                <DialogContent dividers>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('master_air_waybill')}</InputLabel>   
                        </span>  
                        <TextField 
                            id="masterAirWayBill"
                            select
                            //label={t('master_air_waybill')}
                            InputLabelProps={{ shrink: true }}                
                            variant="outlined"
                            value={masterAirWayBill}
                            onChange={handleMAWBChange}
                            SelectProps={{
                                native: true,
                            }}                             
                            style={{width: 200, paddingRight: 16}}                        
                        >  
                        {masterAirWayBillList.map((item,index) => (
                            <option key={item.label +  index} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                        </TextField>
                    </div>
                    <Divider/>
                    {/* <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_status')}</InputLabel>   
                        </span>  
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_count')}</InputLabel>   
                        </span>  
                    </div> */}
                    {mawbstatistics.map((item,index)=>(
                        index % ROW_MAX_COLUMN === 0 
                        ?
                        <div style={{display: 'flex', flexDirection: 'row', padding: 16}} key={item + index}>
                        {
                            mawbstatistics.map((ele,idx)=>{
                                if (   
                                        (idx >= ((index / ROW_MAX_COLUMN) * ROW_MAX_COLUMN)) && 
                                        (idx < ((index / ROW_MAX_COLUMN + 1) * ROW_MAX_COLUMN))
                                    ) {                            
                                    return (                            
                                        <TextField 
                                            id={item.pathInfo}
                                            label={t(item.pathInfo)}
                                            InputLabelProps={{ shrink: true }}  
                                            variant="outlined"                    
                                            value={item.qty}
                                            disabled={true}
                                            style={{width: 250, paddingRight: 16}}                        
                                        />    
                                    )}
                            })
                        }               
                        </div>                        
                        :
                        null
                    ))}
                    {/* <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_unscanned')}</InputLabel>   
                        </span>                                    
                        <TextField 
                            id="unscanned"
                            value={unscanned}
                            disabled={true}
                            style={{width: 200, paddingRight: 16}}                        
                        />    
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_delivered')}</InputLabel>   
                        </span>                                    
                        <TextField 
                            id="delivered"
                            value={delivered}
                            disabled={true}
                            style={{width: 200, paddingRight: 16}}                        
                        />    
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_parcel_scanned')}</InputLabel>   
                        </span>                                    
                        <TextField 
                            id="parcelScanned"
                            value={parcelScanned}
                            disabled={true}
                            style={{width: 200, paddingRight: 16}}                        
                        />    
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_return_storage')}</InputLabel>   
                        </span>                                    
                        <TextField 
                            id="returnStorage"
                            value={returnStorage}
                            disabled={true}
                            style={{width: 200, paddingRight: 16}}                        
                        />    
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_in_storage')}</InputLabel>   
                        </span>                                    
                        <TextField 
                            id="inStorage"
                            value={inStorage}
                            disabled={true}
                            style={{width: 200, paddingRight: 16}}                        
                        />    
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                        <span style={{width: 200, marginRight: 20}}>
                            <InputLabel variant="filled">{t('label_statics_in_transit')}</InputLabel>   
                        </span>                                    
                        <TextField 
                            id="inTransit"
                            value={inTransit}
                            disabled={true}
                            style={{width: 200, paddingRight: 16}}                        
                        />    
                    </div> */}
                </DialogContent>  
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        {t('common:cancel')}
                    </Button>
                </DialogActions>                          
            </Dialog>
    )


    /**
     *  set the master air way bill
     */
    function init() {
        let arr = [];
        
        batchList.map((item,index)=>(
            arr.push({label: item.master_air_waybill, value: item.master_air_waybill})
        ));
        if (arr.length > 0) 
            arr.unshift({label: t('option_pls_select'), value: OPTION_PLS_SELECT});
        setMasterAirWayBillList(arr);
    };
    
    /**
     * 
     * @param {*} event 
     */
    function handleMAWBChange(event) {
        setMasterAirWayBill(event.target.value);

        if (event.target.value !== OPTION_PLS_SELECT) {
            dispatch(getmawbstatistics(event.target.value));        
        }
    }

    /**
     * Close the MessageSnackbar
     * Call the prarent function to handle the status after this dialoge is closed
     */
    function handleClose() {    
        onClose();
    };

}

